import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private requestCount = 0;
  private visibleSubject = new BehaviorSubject<boolean>(false);

  visible$ = this.visibleSubject.asObservable();

  show() {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.visibleSubject.next(true);
    }
  }

  hide() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this.visibleSubject.next(false);
    }
  }

  forceHide() {
    this.requestCount = 0;
    this.visibleSubject.next(false);
  }
}
